import { FC, useMemo } from "react";
import { scoreToDisplayStars } from "../../../config/rating";
import { IWidgetTemplate } from "../../../interfaces/widget-template";
import { ReachClick } from "../../../utils/core";
import { resolveWidgetV2Style } from "./widgetV2Styles";

const Stat: FC<{ value: string | number; label: string }> = ({ value, label }) => (
  <div className="text-center">
    <b style={{ display: "block", fontSize: 17, color: "#006bf1", lineHeight: 1 }}>{value}</b>
    <div style={{ fontSize: 9, color: "#6b6b85", marginTop: 2 }}>{label}</div>
  </div>
);

/**
 * Number Counter (v2) — admin-preview-only. Shows the real, current review
 * count on each load/refresh — not a live-ticking animation (see the
 * design-mock note recorded when this variant was scoped down).
 * Real embed markup lives in widget-v2.js (renderCounter).
 */
const WidgetTemplate31: FC<IWidgetTemplate> = ({ company, score, style }) => {
  const companyId = company?.companyId;
  const resolvedStyle = resolveWidgetV2Style("counter", style);
  const payload = useMemo(() => ({ companyId, widgetId: 31 as const }), [companyId]);
  const profileUrl = useMemo(
    () => `https://www.trustfinance.com/companies/${companyId}?utm_source=widget&utm_medium=dom&utm_campaign=widget-v2-counter`,
    [companyId],
  );

  if (resolvedStyle === "combined-stats") {
    return (
      <div className="d-flex justify-content-center">
        <a href={profileUrl} target="_blank" rel="noopener" onClick={() => ReachClick(payload)} className="d-flex gap-4" style={{ textDecoration: "none", color: "#1c1c2e" }}>
          <Stat value={(score?.totalReview ?? 0).toLocaleString()} label="reviews" />
          <Stat value={scoreToDisplayStars(score?.score ?? 0)} label="rating" />
          <Stat value={score?.score ?? 0} label="TrustScore" />
        </a>
      </div>
    );
  }

  return (
    <div className="d-flex justify-content-center">
      <a
        href={profileUrl}
        target="_blank"
        rel="noopener"
        onClick={() => ReachClick(payload)}
        className="text-center"
        style={{ textDecoration: "none", color: "#1c1c2e" }}
      >
        <div style={{ fontWeight: 700, fontSize: 22, color: "#006bf1", lineHeight: 1 }}>{(score?.totalReview ?? 0).toLocaleString()}</div>
        <div style={{ fontSize: 10, color: "#6b6b85", marginTop: 2 }}>verified reviews and counting</div>
      </a>
    </div>
  );
};

export default WidgetTemplate31;
